<template>
  <div class="wrapper">
    <div id="login">
      <form class="login-form" @submit.prevent="onSubmit">
        <div class="form-img">
          <img src="@/assets/logo.png" alt="Logo" />
        </div>

        <div class="otp-title">
          <h2>OTP код баталгаажуулах</h2>
          <p>Таны утсанд ирсэн баталгаажуулах кодыг оруулна уу.</p>
        </div>

        <div class="form-item otp-form-item">
          <label>OTP код</label>

          <div class="otp-inputs">
            <input
              v-for="(digit, index) in otpDigits"
              :key="index"
              ref="otpInputs"
              v-model="otpDigits[index]"
              type="text"
              inputmode="numeric"
              maxlength="1"
              class="otp-cell"
              :disabled="isDisabled"
              @input="onOtpInput(index)"
              @keydown="onOtpKeydown($event, index)"
              @paste="onOtpPaste"
            />
          </div>
        </div>

        <transition name="error">
          <div v-if="error" class="form-error form-error-out">
            <div class="error-icon">
              <i class="fa fa-exclamation-triangle"></i>
            </div>
            <div class="error-message">
              <p>{{ errorMessage }}</p>
            </div>
          </div>
        </transition>

        <transition name="error">
          <div v-if="success" class="form-success form-error-out">
            <div class="error-icon">
              <i class="fa fa-check-circle"></i>
            </div>
            <div class="error-message">
              <p>{{ successMessage }}</p>
            </div>
          </div>
        </transition>

        <div class="form-item">
          <input
            class="login-btn"
            type="submit"
            :disabled="isDisabled"
            :value="isDisabled ? 'Шалгаж байна...' : 'Баталгаажуулах'"
          />
        </div>

        <div class="form-item">
          <button
            type="button"
            class="login-btn resend-btn"
            :disabled="isDisabled || isResending"
            @click="resendOtp"
          >
            {{ isResending ? "Илгээж байна..." : "Нууц үг дахин авах" }}
          </button>
        </div>

        <div class="form-last-text">
          <span></span>
          <a @click="$router.push({ name: 'login' })">Буцах</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "otp",

  data() {
    return {
      otpDigits: ["", "", "", ""],

      error: false,
      errorMessage: "",

      success: false,
      successMessage: "",

      isDisabled: false,
      isResending: false,
    };
  },

  methods: {
    onOtpInput(index) {
      let value = this.otpDigits[index] || "";

      value = value.replace(/\D/g, "").slice(0, 1);

      this.$set(this.otpDigits, index, value);

      if (value && index < this.otpDigits.length - 1) {
        this.$nextTick(() => {
          this.$refs.otpInputs[index + 1].focus();
        });
      }
    },

    onOtpKeydown(event, index) {
      if (event.key === "Backspace" && !this.otpDigits[index] && index > 0) {
        this.$nextTick(() => {
          this.$refs.otpInputs[index - 1].focus();
        });
      }
    },

    onOtpPaste(event) {
      event.preventDefault();

      const pastedValue = event.clipboardData
        .getData("text")
        .replace(/\D/g, "")
        .slice(0, 4);

      pastedValue.split("").forEach((number, index) => {
        this.$set(this.otpDigits, index, number);
      });

      const nextIndex = pastedValue.length >= 4 ? 3 : pastedValue.length;

      this.$nextTick(() => {
        if (this.$refs.otpInputs[nextIndex]) {
          this.$refs.otpInputs[nextIndex].focus();
        }
      });
    },

    getSavedLoginData() {
      try {
        return JSON.parse(sessionStorage.getItem("otpLoginPayload") || "{}");
      } catch (error) {
        return {};
      }
    },

    clearMessages() {
      this.error = false;
      this.errorMessage = "";
      this.success = false;
      this.successMessage = "";
    },

    showError(message) {
      Vue.prototype.globalError = false;
      this.success = false;
      this.successMessage = "";
      this.error = true;
      this.errorMessage = message;
    },

    showSuccess(message) {
      this.error = false;
      this.errorMessage = "";
      this.success = true;
      this.successMessage = message;
    },

    async resendOtp() {
      this.clearMessages();

      const savedLoginData = this.getSavedLoginData();

      if (!savedLoginData.username) {
        this.showError("Нэвтрэх мэдээлэл олдсонгүй. Дахин нэвтэрнэ үү.");
        return;
      }

      this.isResending = true;
      this.$insProgress.start();

      try {
        const isCardId = savedLoginData.type === "cardId";
        const isPhone = savedLoginData.type === "phone";

        const response = await this.$cardApi.post(
          "/otp/send",
          {
            referenceId: isCardId ? savedLoginData.username : "",
            purpose: "LOGIN",
            channel: "SMS",
            receiver: isPhone ? savedLoginData.username : "",
            systemId: "BonusWeb",
          },
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        );

        const data = response.data || {};

        if (data.success === true || data.status === "SUCCESS") {
          this.showSuccess(data.message || "OTP код дахин илгээгдлээ.");
        } else {
          this.showError(data.message || "OTP дахин илгээхэд алдаа гарлаа.");
        }
      } catch (error) {
        const message =
          error.response &&
          error.response.data &&
          error.response.data.message
            ? error.response.data.message
            : "OTP дахин илгээхэд алдаа гарлаа.";

        this.showError(message);
      } finally {
        this.isResending = false;
        this.$insProgress.finish();
      }
    },

    onSubmit() {
      this.clearMessages();

      const otp = this.otpDigits.join("");

      if (otp.length === 0) {
        this.showError("OTP код оруулна уу");
        return;
      }

      if (otp.length < 4) {
        this.showError("OTP код бүрэн оруулна уу");
        return;
      }

      if (!/^\d+$/.test(otp)) {
        this.showError("Та зөвхөн тоо оруулна уу");
        return;
      }

      const savedLoginData = this.getSavedLoginData();

      if (!savedLoginData.username || !savedLoginData.password) {
        this.showError("Нэвтрэх мэдээлэл олдсонгүй. Дахин нэвтэрнэ үү.");
        return;
      }

      this.isDisabled = true;
      this.$insProgress.start();

      this.$cardApi.post(
        "/auth/bonus/login",
        {
          cardNumber: savedLoginData.username,
          password: savedLoginData.password,
          type: savedLoginData.type || "phone",
          systemId: "BonusWeb",
          deviceId: savedLoginData.deviceId || "",
          loginOtp: otp,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": "mn",
          },
        }
      )
      .then((response) => {
        const result = response.data || {};

        if (result.status === 0 && result.token) {
          sessionStorage.removeItem("otpLoginPayload");
          this.afterLoginSuccess(result);
        } else {
          this.isDisabled = false;
          this.showError(result.message || "OTP код буруу байна");
          this.$insProgress.finish();
        }
      })
      .catch((error) => {
        this.isDisabled = false;

        const message =
          error.response &&
          error.response.data &&
          error.response.data.message
            ? error.response.data.message
            : "OTP шалгахад алдаа гарлаа.";

        this.showError(message);
        this.$insProgress.finish();
      });
    },

    afterLoginSuccess(data) {
      this.$auth.setToken(data.token);
      this.$auth.setMe(data);

      this.$bonusApi
        .post(
          "bonus-card/info/token",
          {
            tokenId: data.token,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          const result = response.data || {};

          this.$auth.removeCardInfo();
          this.$auth.setCardInfo(response.data);

          if (result.status === 0) {
            this.$router.push({ name: "homeDashboard" });
          } else if (result.status === 201) {
            this.logoutToLogin();
          }

          this.$insProgress.finish();
        })
        .catch(() => {
          this.logoutToLogin();
          this.$insProgress.finish();
        });
    },

    logoutToLogin() {
      this.$auth.destroyToken();
      this.$auth.removeMe();
      sessionStorage.removeItem("otpLoginPayload");
      this.$router.push({ name: "login" });
    },
  },

  created() {
    if (this.$auth.loggedIn()) {
      this.$router.push("profile");
    }
  },
};
</script>

<style scoped>
.otp-title {
  margin-top: 45px;
  margin-bottom: 28px;
  text-align: center;
}

.otp-title h2 {
  margin: 0 0 10px;
  font-family: "Roboto";
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}

.otp-title p {
  margin: 0;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: 300;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.6);
}

.form-item {
  margin-bottom: 0;
}

.otp-form-item label {
  margin-bottom: 13px;
}

.otp-inputs {
  display: flex;
  justify-content: center;
  gap: 12px;
  width: 280px;
}

.otp-inputs .otp-cell {
  width: 48px;
  height: 42px;
  border-radius: 5px;
  background-color: #f5f5f5;
  text-align: center;
  font-family: "Roboto";
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}
.resend-btn {
  margin-top: 10px;
  background: none;
  color: #1660ab;
  border: none;
}

.form-success {
  background: #e8f8ee;
  color: #16803c;
  border: 1px solid #b7ebc6;
}
.otp-inputs .otp-cell:focus {
  outline: none;
  border: 1px solid #1660ab;
  background-color: #ffffff;
}

.otp-inputs .otp-cell:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.form-item input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.form-last-text {
  margin-top: 20px;
}

@media only screen and (max-width: 400px) {
  .otp-inputs {
    width: 100%;
    gap: 8px;
  }

  .otp-inputs .otp-cell {
    width: 44px;
  }
}
</style>